import React, { useState } from 'react'
import SvgImage from '../../Icons/Icons'
import { Button } from 'reactstrap'
import { useSelector } from 'react-redux';
import PaySalaryModal from '../../Modals/PaySalaryModal';
import EditSalaryModal from '../../Modals/editSalaryModal';

 const PaySalary = (props) => {
    const {driverDetails}= props;
    const { salaryWalletDetails } = useSelector(
        state => state?.driverlist,
      );
    const [modal, setModal] = useState(false);
    const toggleInfo = () => setModal(!modal);

    const [modalEditSalary, setModalEditSalary] = useState(false);
    const toggleEdit = () => setModalEditSalary(!modalEditSalary);
  return (
    <div>
        <div className='main'>
            <div className='mainSalary'>
                    <div className='boxShadowIntro container22 container21'>
                        <div className='SalaryData'>
                            <div className='svgDiv'>
                                <SvgImage name='wallet' />
                            </div>
                            <div className='driverSalary'>
                                <span>Driver Salary: ₹{salaryWalletDetails?.salary ? salaryWalletDetails?.salary : 'N/A' }</span>
                                <span onClick={toggleEdit} style={salaryWalletDetails?.salary ? {paddingBottom:'3px', cursor:'pointer'}: {display:'none'}}>
                                    <SvgImage name='editSmall' />
                                </span>
                            </div>
                            
                        </div>
                        <div className='partition'></div>
                        <div className='SalaryData'>
                            <div className='svgDiv'>
                                <SvgImage name='calendar' />
                            </div>
                            <div className='driverSalary'>
                                    <span>Last Paid Salary: ₹{ salaryWalletDetails?.lastSalaryAmount ? salaryWalletDetails?.lastSalaryAmount : "N/A"}</span> 
                            </div>
                        </div>
                    </div>
            </div>
            <Button 
            style={{color:'#FFF', background:'#485B7C', width:'300px', alignSelf:'center'}}
            onClick={toggleInfo}
            >
                Pay Salary
            </Button>
        </div>
        <EditSalaryModal driverDetails={driverDetails} open={modalEditSalary} toggleModal={toggleEdit}/>
        <PaySalaryModal driverDetails={driverDetails} open={modal} toggleModal={toggleInfo}/>
    </div>
  )
}

 export default PaySalary 